/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {Route, Routes} from 'react-router-dom';
import {ExdsTheme} from '@exds/theme';
import './App.scss';
import ValidateIdentityInternal from './components/ValidateIdentityInternal/ValidateIdentityInternal';
import ValidateIdentityExternal from './components/ValidateIdentityExternal/ValidateIdentityExternal';
import CreatePassword from './components/CreatePassword/CreatePassword';
import SecurityQuestions from './components/SecurityQuestions/SecurityQuestions';
import {AppContextProvider} from './AppContext';
import MobileAppSetup from './components/MobileAppSetup/MobileAppSetup';
import FinishScreen from './components/Finish/FinishScreen';
import React, {Component} from 'react';
import InvalidDevice from './components/InvalidDevice/InvalidDevice';
import IntroScreen from './components/IntroScreen/IntroScreen';
import {apiGet} from './service/service';
import NotFound from './components/NotFound/NotFound';
import {loadAAModule} from "./components/AdobeAnalytics/AdobeAnalytics";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: null,
      isLargeScreen: window.innerWidth >= 768
    };
  }

  async componentDidMount() {
    await this.getConfig();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  asyncSetState(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async getConfig() {
    apiGet('/api/config')
      .then(async (data) => {
        if(data.adobeAnalyticsUrl && data.adobeAnalyticsUrl !== '') {
          loadAAModule(data.adobeAnalyticsUrl);
        }
        await this.asyncSetState({ config: data });
      });
  }

  handleResize = () => {
    this.setState({ isLargeScreen: window.innerWidth >= 768 });
  };

  renderValidateIdentity = () => {
    const { config } = this.state;

    if(!config) return <></>;

    if (config?.external) {
      return <ValidateIdentityExternal />;
    } else {
      return <ValidateIdentityInternal />;
    }
  };

  render() {
    const { isLargeScreen } = this.state;

    return (
      <AppContextProvider mppUrl={this.state.config?.mppUrl} external={this.state.config?.external} loadAA={this.state.config?.adobeAnalyticsUrl !== ''}>
        <main id='main'>
          <div className="app-container">
            {!isLargeScreen && <div><InvalidDevice /></div>}
            <div className={`${isLargeScreen ? '' : 'small-screen'}`}>
              <ExdsTheme>
                <Routes>
                  <Route path="/" element={<IntroScreen />} />
                  <Route path="/validateIdentity" element={this.renderValidateIdentity()} />
                  <Route path="/createPassword" element={<CreatePassword />} />
                  <Route path="/securityQuestions" element={<SecurityQuestions />} />
                  <Route path="/mobileAppSetup" element={<MobileAppSetup />} />
                  <Route path="/finish" element={<FinishScreen />}/>
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </ExdsTheme>
            </div>
          </div>
        </main>
      </AppContextProvider>
    );
  }
}

export default App;
